import translations from './tin.content'
import type { Metal } from './types'

const t = translations
const dir = '/mine-my-phone/images/metals/tin'

export const tin: Metal = {
  id: 4,
  slug: 'tin',
  name: t.name,
  symbol: 'Sn',
  // The sheet's five pins: Bangka and Belitung are now two pins rather than the one
  // combined marker, and the operator names go, since the sheet gives none. Every pin is
  // in Asia or South America — there is none in the DRC, though the sheet lists it at
  // 8.3% and half the human and environmental copy is about it.
  mines: [
    {
      name: 'Gejiu (China)',
      region: 'Gejiu',
      coordinates: [103.16, 23.36],
    },
    {
      name: 'Bangka Island (Indonesia)',
      region: 'Bangka Island',
      coordinates: [106.1, -2.3],
    },
    {
      name: 'Belitung Island (Indonesia)',
      region: 'Belitung Island',
      coordinates: [107.9, -2.85],
    },
    {
      name: 'San Rafael (Peru)',
      region: 'San Rafael',
      coordinates: [-70.32, -14.2],
    },
    {
      name: 'Pitinga (Brazil)',
      region: 'Pitinga',
      coordinates: [-60.1, -0.75],
    },
  ],
  // Six, as the sheet lists them — the DRC was missing from the placeholder set.
  countries: [
    { name: 'China', percent: 23 },
    { name: 'Indonesia', percent: 16.7 },
    { name: 'Myanmar', percent: 11.3 },
    { name: 'Peru', percent: 10.3 },
    { name: 'Brazil', percent: 9.7 },
    { name: 'DRC', percent: 8.3 },
  ],
  important: true,
  // The sheet's three, in its order: the rest of the 3TG conflict minerals.
  related: ['tantalum', 'gold', 'tungsten'],
  video: { name: 'tin', poster: '/mine-my-phone/images/posters/tin.jpg' },
  // Scores and imagery are authored here; every word comes from the translations file.
  content: {
    smartphone: {
      quantityScore: 3,
      quantityLabel: t.smartphone.label,
      parts: ['screen', 'electronics'],
    },
    whatItDoes: t.whatItDoes,
    extraction: t.extraction,
    quickFact: t.quickFact,
    impacts: {
      environmental: { severity: 2, ...t.impacts.environmental },
      human: { severity: 2, ...t.impacts.human },
      geopolitical: { severity: 4, ...t.impacts.geopolitical },
    },
    supplyRisk: { score: 4, ...t.supplyRisk },
    recycling: { score: 3, ...t.recycling },
    footnotes: t.footnotes,
    photos: {
      hero: {
        src: `${dir}/01.jpg`,
        orientation: 'horizontal',
      },
      firstBento: [
        {
          src: `${dir}/02.jpg`,
          orientation: 'vertical',
        },
        {
          src: `${dir}/03.jpg`,
          orientation: 'vertical',
        },
        {
          src: `${dir}/04.jpg`,
          orientation: 'horizontal',
          credit: 'Bloomberg / Getty',
        },
      ],
      secondBento: [
        {
          src: `${dir}/05.jpg`,
          orientation: 'horizontal',
          credit: 'Keystone-France / Getty',
        },
        {
          src: `${dir}/06.jpg`,
          orientation: 'vertical',
          credit: 'Guillaume Collanges',
        },
        {
          src: `${dir}/07.jpg`,
          orientation: 'vertical',
          credit: 'Guillaume Collanges',
        },
        {
          src: `${dir}/08.jpg`,
          orientation: 'horizontal',
          credit: 'Guillaume Collanges',
        },
        {
          src: `${dir}/09.jpg`,
          orientation: 'horizontal',
          credit: 'Guillaume Collanges',
        },
      ],
    },
  },
}
